import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

// Spotlight prehliadka admina cez driver.js — kroky sa viažu na data-tour
// atribúty v Sidebar (desktop). Nedostupné/skryté ciele sa automaticky vynechajú.

const TOUR_TARGETS = [
    { selector: '[data-tour="/dashboard"]', key: 'dashboard' },
    { selector: '[data-tour="/employees"]', key: 'employees' },
    { selector: '[data-tour="/workplaces"]', key: 'workplaces' },
    { selector: '[data-tour="/automations"]', key: 'automations' },
    { selector: '[data-tour="/export"]', key: 'export' },
    { selector: '[data-tour="/asistent"]', key: 'asistent' },
    { selector: '[data-tour="/requests"]', key: 'requests' },
    { selector: '[data-tour="/activity"]', key: 'activity' },
    { selector: '[data-tour="profile-card"]', key: 'profile' },
];

const isVisible = (selector) => {
    const el = document.querySelector(selector);
    return Boolean(el && el.offsetParent !== null);
};

export const startAdminTour = (t, onDone) => {
    const steps = TOUR_TARGETS
        .filter(({ selector }) => isVisible(selector))
        .map(({ selector, key }) => ({
            element: selector,
            popover: {
                title: t(`onboardingFlow.tour.${key}Title`),
                description: t(`onboardingFlow.tour.${key}Desc`),
            },
        }));

    if (!steps.length) return false;

    const tour = driver({
        showProgress: true,
        progressText: '{{current}} / {{total}}',
        nextBtnText: t('onboardingFlow.tour.next'),
        prevBtnText: t('onboardingFlow.tour.prev'),
        doneBtnText: t('onboardingFlow.tour.done'),
        overlayOpacity: 0.6,
        stagePadding: 6,
        stageRadius: 16,
        popoverClass: 'effzone-tour-popover',
        onDestroyed: () => {
            if (onDone) onDone();
        },
        steps,
    });
    tour.drive();
    return true;
};
